<template>
<div>
    <div class="mb-3">
        <img src="../../../assets/images/book/book-title-logo.png" alt="" class="book-title-logo">
        <div class="book-titles">
            <span class="book-title">{{BookParentTitle}}</span> <span class="book-title-2">{{BookSubTitle}}</span>
            <span class="book-sub-title">Words</span>
        </div>
        <div style="clear: both;"></div>
    </div>
    <SubjectBookImage v-if="sectionImageUrl" :url="sectionImageUrl" banner alt="Kelimeler bölümü görseli" />
    <div class="book-contents">
        <div class="book-bg">
            <img src="../../../assets/images/book/book-bg-logo.png" class="lengedu-logo">
        </div>
        <div class="book-content">
            <div class="accordion" :id="`acc-${uid}`">
                <div v-for="(w, i) in wordList" :key="i" class="accordion-item border rounded-3 mb-2">
                <h2 class="accordion-header d-flex align-items-center">
                    <button
                    class="accordion-button"
                    :class="{ collapsed: !openWords[i] }"
                    type="button"
                    @click="toggleWord(i)"
                    :aria-controls="`c-${uid}-${i}`"
                    :aria-expanded="!!openWords[i]"
                    >
                    <div class="d-flex align-items-center gap-2 w-100">
                        <!-- left -->
                        <div class="d-flex align-items-center gap-2 flex-grow-1">
                        <span class="fw-semibold fs-5">{{ w.wordText }}</span>
                        </div>

                        <!-- right -->
                        <div class="text-end me-2">
                            <div class="fw-semibold">{{ w.equivalent }}</div>
                        </div>
                    </div>
                    </button>
                    <button class="word-audio mx-2" type="button" :aria-label="`${w.wordText} telaffuzunu dinle`" title="Telaffuzu dinle" @click="playAudio(w)"><i class="bi bi-volume-up-fill" aria-hidden="true"></i></button>
                </h2>
                <div :id="`c-${uid}-${i}`" class="accordion-collapse collapse" :class="{ show: openWords[i] }">
                    <div class="accordion-body word-details">
                        <div v-if="w.pronunciation || w.partOfSpeechEn" class="word-meta">
                            <span v-if="w.pronunciation" class="word-pronunciation">{{ w.pronunciation }}</span>
                            <span v-if="w.partOfSpeechEn" class="word-type">{{ w.partOfSpeechEn }}</span>
                        </div>

                        <section class="word-section" aria-label="Tanım">
                            <h3 class="word-section-title">Tanım</h3>
                            <div class="word-line">
                                <p class="word-text">{{ w.gloss || "-" }}</p>
                                <button v-if="w.gloss?.trim()" class="word-audio" type="button" :aria-label="`${w.wordText} İngilizce tanımını dinle`" title="Tanımı dinle" @click="playExample(w.gloss)"><i class="bi bi-volume-up-fill" aria-hidden="true"></i></button>
                            </div>
                            <p class="word-translation">({{ w.definition || "-" }})</p>
                        </section>

                        <section v-if="w.examples?.length" class="word-section word-examples" aria-label="Örnek cümleler">
                            <h3 class="word-section-title">Örnek cümleler</h3>
                            <div v-for="(ex, idx) in w.examples" :key="idx" class="word-example">
                                <div class="word-line">
                                    <p class="word-text">{{ ex.sentence }}</p>
                                    <button v-if="ex.sentence?.trim()" class="word-audio" type="button" :aria-label="`${ex.sentence} cümlesini dinle`" title="Cümleyi dinle" @click="playExample(ex.sentence)"><i class="bi bi-volume-up-fill" aria-hidden="true"></i></button>
                                </div>
                                <p class="word-translation">({{ ex.translation || "-" }})</p>
                            </div>
                        </section>
                    </div>
                </div>
                </div>
            </div>
            <audio style="display: none;" controls ref="WordPlay" src=""></audio>
        </div>
    </div>
</div> 
</template>
<script>
import { mapActions } from "vuex";
import { markRaw } from "vue";
import { LoadingToast,UpdateToast,ToastType,ErrorToast } from "@/common/notification.js";
import '../../../assets/styles/book-design.css';
import SubjectBookImage from './SubjectBookImage.vue';
  export default {
    name: "TabLearnWordNew",
    components: { SubjectBookImage },
    props: {
      sectionImageUrl: { type: String, default: '' },
      words:{
        type:Array
      },
      bookTitle:{
        type: Object
      }
    },
    data() {
      return {
        uid: Math.random().toString(36).slice(2),
        openWords: {},
        audioRequest: 0,
        speechVoices: [],
        activeSpeech: null,
        previousAudioSessionType: null,
        wordList:[]
      }
    },
    computed: {
       BookParentTitle(){
        if(this.bookTitle){
            return this.bookTitle.bookParentTitle;
        }
        return '';
       },
       BookSubTitle(){
        if(this.bookTitle){
            return this.bookTitle.bookSubTitle;
        }
        return '';
       }
    },
    methods: {
        ...mapActions(["SearchWordCards"]),
       toggleWord(index) {
            this.openWords[index] = !this.openWords[index];
       },
       async init(){
            let toastId = LoadingToast();
            await this.SearchWordCards(this.words)
            .then((res)=>{
                this.wordList = res;
                this.openWords = {};
                UpdateToast(toastId,res.description,ToastType().SUCCESS);
            })
            .catch((err)=>{
                UpdateToast(toastId,err.message,ToastType().ERROR);
            });
       },
       stopAudio() {
            this.audioRequest++;
            const audio = this.$refs.WordPlay;
            if (audio) { audio.onerror = null; audio.pause(); audio.removeAttribute('src'); audio.load(); }
            const synth = window.speechSynthesis;
            if (synth && (synth.speaking || synth.pending)) synth.cancel();
            this.activeSpeech = null;
            this.restoreAudioSession();
       },
       prepareAudioSession() {
            try {
                const session = navigator.audioSession;
                // Do not override a session being used for microphone capture.
                if (!session || session.type === 'play-and-record' || session.type === 'playback') return;
                const previousType = session.type;
                session.type = 'playback';
                this.previousAudioSessionType = previousType;
            } catch { /* Optional API: speech remains available without it. */ }
       },
       restoreAudioSession() {
            try {
                if (this.previousAudioSessionType !== null && navigator.audioSession?.type === 'playback')
                    navigator.audioSession.type = this.previousAudioSessionType;
            } catch { /* The browser may have already released the session. */ }
            this.previousAudioSessionType = null;
       },
       loadSpeechVoices() {
            this.speechVoices = (window.speechSynthesis?.getVoices() || []).map(voice => markRaw(voice));
       },
       speakWord(text, request) {
            if (request !== this.audioRequest) return;
            if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) {
                ErrorToast('Ses kaydı bulunamadı ve bu cihaz otomatik seslendirmeyi desteklemiyor.');
                return;
            }
            try {
                const speech = new window.SpeechSynthesisUtterance(text);
                const synth = window.speechSynthesis;
                this.loadSpeechVoices();
                const englishVoices = this.speechVoices.filter(v => /^en([-_]|$)/i.test(v.lang));
                const voice = englishVoices.find(v => v.localService && /^en[-_]us$/i.test(v.lang))
                    || englishVoices.find(v => v.localService)
                    || englishVoices.find(v => /^en[-_]us$/i.test(v.lang))
                    || englishVoices[0];
                speech.lang = voice ? voice.lang : 'en-US';
                if (voice) speech.voice = voice;
                this.activeSpeech = markRaw(speech);
                speech.onend = () => {
                    if (request !== this.audioRequest) return;
                    this.activeSpeech = null;
                    this.restoreAudioSession();
                };
                speech.onerror = event => {
                    if (request !== this.audioRequest) return;
                    this.activeSpeech = null;
                    this.restoreAudioSession();
                    if (['canceled', 'interrupted'].includes(event.error)) return;
                    ErrorToast(event.error === 'not-allowed'
                        ? 'Seslendirmeye izin verilmedi. Ses düğmesine tekrar dokunun.'
                        : 'Telaffuz oynatılamadı. Cihazın İngilizce ses desteğini kontrol edin.');
                };
                // Keep speak synchronous with the tap; awaiting voices can lose user activation.
                this.prepareAudioSession();
                if (synth.paused) synth.resume();
                synth.speak(speech);
            } catch {
                this.activeSpeech = null;
                this.restoreAudioSession();
                ErrorToast('Bu cihazda otomatik seslendirme başlatılamadı.');
            }
       },
       playExample(sentence) {
            this.stopAudio();
            const text = (sentence || '').trim();
            if (text) this.speakWord(text, this.audioRequest);
       },
       async playAudio(word) {
            this.stopAudio();
            const request = this.audioRequest;
            const text = (word.wordText || '').trim();
            if (!text) return;
            const source = (word.audioUrl || '').trim();
            if (!source) { this.speakWord(text, request); return; }
            const audio = this.$refs.WordPlay;
            let fallbackStarted = false;
            const fallback = () => {
                if (request !== this.audioRequest || fallbackStarted) return;
                fallbackStarted = true;
                audio.onerror = null;
                audio.pause();
                this.speakWord(text, request);
            };
            try {
                const root = process.env.VUE_APP_ROOT_API.replace(/\/?$/, '/');
                // Keep support for legacy dictionary filenames as well as actual audio URLs.
                const url = /^(https?:)?\/\//i.test(source) || source.includes('/')
                    ? new URL(source, root).href
                    : root + 'Source/dictionary/audio?word=' + encodeURIComponent(source.replace(/\.mp3$/i, ''));
                audio.onerror = fallback;
                audio.src = url;
                await audio.play();
            } catch { fallback(); }
       },
    },
    mounted: function() {
        this.loadSpeechVoices();
        window.speechSynthesis?.addEventListener('voiceschanged', this.loadSpeechVoices);
        this.init()
    },
    beforeUnmount() {
        window.speechSynthesis?.removeEventListener('voiceschanged', this.loadSpeechVoices);
        this.stopAudio();
    }
  };
  </script>
    
<style scoped>
    .word-details {
        padding: 1.25rem;
        color: #334155;
        font-size: 1rem;
        line-height: 1.65;
        border-top: 1px solid #edf0f3;
    }

    .word-meta {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.75rem;
        margin-bottom: 1.25rem;
        color: #64748b;
        font-size: 0.875rem;
    }

    .word-type {
        padding: 0.125rem 0.625rem;
        border-radius: 0.375rem;
        background: #f1f5f9;
        color: #475569;
        font-size: 0.8125rem;
    }

    .word-section-title {
        margin: 0 0 0.5rem;
        color: #64748b;
        font-size: 0.8125rem;
        font-weight: 600;
        line-height: 1.5;
    }

    .word-line {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;
    }

    .word-text {
        min-width: 0;
        margin: 0;
        overflow-wrap: anywhere;
    }

    .word-translation {
        margin: 0.25rem 0 0;
        color: #64748b;
        font-size: 0.875rem;
        overflow-wrap: anywhere;
    }

    .word-examples {
        margin-top: 1.25rem;
        padding-top: 1.25rem;
        border-top: 1px solid #edf0f3;
    }

    .word-example + .word-example {
        margin-top: 1rem;
    }

    .word-audio {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 2rem;
        height: 2rem;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: #f1f5f9;
        color: #52647a;
        font-size: 1rem;
        cursor: pointer;
    }

    .word-audio:hover {
        background: #e2e8f0;
        color: #334155;
    }

    .word-audio:focus-visible {
        outline: 2px solid #64748b;
        outline-offset: 3px;
    }

    @media (max-width: 575px) {
        .word-details {
            padding: 1rem;
        }

        .word-audio {
            width: 2.5rem;
            height: 2.5rem;
        }
    }

    .accordion-button:not(.collapsed) {
        background-color: #f8f9fa !important;
        box-shadow: none !important;
    }

    .accordion-button:focus {
        box-shadow: none !important;
    }
</style>
